// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DP6Awz_TMtYH8sXK{border-radius:1000px}.QNiPv0MeM0Q3L1S5{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.cBIWHG8SqGQPKjT0{display:flex;flex-direction:column;justify-content:center;align-items:center}.W5yfOwMDZZU1XJgL{animation:EzEYSSh8aw_whSeE 3s infinite;animation-iteration-count:infinite}@keyframes EzEYSSh8aw_whSeE{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.hk9NSCPW5lIhA5Iv{text-align:center;padding:10px}.a572qWQeB7YMs984{margin-bottom:10px;font-size:16px;line-height:24px;font-weight:700}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `DP6Awz_TMtYH8sXK`,
	"text-truncate": `QNiPv0MeM0Q3L1S5`,
	"shaquille": `cBIWHG8SqGQPKjT0`,
	"shimmer": `W5yfOwMDZZU1XJgL`,
	"placeHolderShimmer": `EzEYSSh8aw_whSeE`,
	"infoContainer": `hk9NSCPW5lIhA5Iv`,
	"modalDescription": `a572qWQeB7YMs984`
};
export default ___CSS_LOADER_EXPORT___;
